"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemperatureUnitContext = exports.useTemperatureUnit = void 0;
const react_1 = __importStar(require("react"));
const use_persisted_state_1 = __importDefault(require("use-persisted-state"));
const useBrowserLocale_1 = require("./useBrowserLocale");
const react_router_dom_1 = require("react-router-dom");
const temperature_1 = require("@yanzi/temperature");
const usePersistedState = use_persisted_state_1.default('default-temperature-unit', window.localStorage);
function useTemperatureUnit() {
    var _a, _b;
    const locale = useBrowserLocale_1.useBrowserLocale();
    const location = react_router_dom_1.useLocation();
    const [contextValue] = react_1.useContext(exports.TemperatureUnitContext);
    const urlUnitString = new URLSearchParams((_a = location === null || location === void 0 ? void 0 : location.search) !== null && _a !== void 0 ? _a : '').get('temperatureUnit');
    const urlUnit = urlUnitString && Number(urlUnitString) in temperature_1.TemperatureUnit ? Number(urlUnitString) : null;
    const [unit, setUnit] = usePersistedState(defaultTemperatureUnit(locale));
    const data = (_b = urlUnit !== null && urlUnit !== void 0 ? urlUnit : contextValue) !== null && _b !== void 0 ? _b : Number(unit);
    return react_1.useMemo(() => [data, setUnit], [data, setUnit]);
}
exports.useTemperatureUnit = useTemperatureUnit;
exports.TemperatureUnitContext = react_1.default.createContext([null]);
const defaultTemperatureUnit = (locale) => {
    switch (locale) {
        case 'en-US':
            return temperature_1.TemperatureUnit.Fahrenheit;
        default:
            return temperature_1.TemperatureUnit.Celsius;
    }
};
exports.default = useTemperatureUnit;
//# sourceMappingURL=useTemperatureUnit.js.map